<script>
/*
* This file created to prevent multiple import css from different SignIn components.
* If you want to change global styles for SignIn project please use style.css file
* */

let signinCssCmp = {
    name: 'signinCss'
};

export { signinCssCmp };
export default signinCssCmp;
</script>

<style lang="scss">
.signin-css {
    @import "style";
}
</style>
